import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

const DevelopmentIcon = () => {
  return (
    <span className="development-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <g id="bg">
          <path
            className="cls-4"
            d="M48,3.1v42.89c0,1.11-.9,2.01-2.01,2.01H2.01c-1.11,0-2.01-.9-2.01-2.01V3.1C0,1.39,1.39,0,3.1,0h41.8c1.71,0,3.1,1.39,3.1,3.1Z"
          />
        </g>
        <g id="dot_left">
          <motion.path
            className="cls-2"
            d="M7.71,4.35c.2,1.09-.74,2.03-1.83,1.82-.61-.12-1.1-.61-1.21-1.22-.2-1.09.74-2.03,1.83-1.82.61.12,1.1.61,1.21,1.22Z"
            animate={{ opacity: [1, 0, 1, 1] }}
            transition={{
              ease: "linear",
              times: [0, 0.01, 0.012, 1],
              duration: 10,
              delay: 6.4,
              repeat: Infinity,
              repeatDelay: 2.856,
            }}
          />
        </g>
        <g id="dot_center">
          <motion.path
            className="cls-1"
            d="M13.91,4.35c.2,1.09-.74,2.03-1.83,1.82-.61-.12-1.1-.61-1.21-1.22-.2-1.09.74-2.03,1.83-1.82.61.12,1.1.61,1.21,1.22Z"
            animate={{ opacity: [1, 0, 1, 1] }}
            transition={{
              ease: "linear",
              times: [0, 0.01, 0.012, 1],
              duration: 10,
              repeat: Infinity,
              repeatDelay: 2.856,
            }}
          />
        </g>
        <g id="dot_right">
          <path
            className="cls-3"
            d="M20.1,4.35c.2,1.09-.74,2.03-1.83,1.82-.61-.12-1.1-.61-1.21-1.22-.2-1.09.74-2.03,1.83-1.82.61.12,1.1.61,1.21,1.22Z"
          />
        </g>
        <motion.g
          animate={{
            x: [
              0, 17.1, 17.1, 8.55, 8.55, 0, 0, 0, 0, 0, 8.55, 8.55, 17.1, 17.1,
              0,
            ],
            y: [0, 0, 0, 14.6, 14.6, 0, 0, 0, 0, 0, 14.6, 14.6, 0, 0, 0],
            rotate: [
              0, 120, 120, 240, 240, 360, 360, 360, 360, 360, 240, 240, 120,
              120, 0,
            ],
          }}
          transition={{
            ease: "linear",
            times: [
              0, 0.0714, 0.1428, 0.2142, 0.2856, 0.357, 0.4284, 0.4998, 0.5712,
              0.6426, 0.714, 0.7854, 0.8568, 0.9282, 1,
            ],
            duration: 10,
            repeat: Infinity,
            repeatDelay: 2.856,
          }}
        >
          <g id="cube_1_top">
            <polygon
              className="cls-1"
              points="15.48 13.94 21.68 17.61 15.48 21.29 9.29 17.61 15.48 13.94"
            />
          </g>
          <g id="cube_1_left">
            <polygon
              className="cls-2"
              points="9.29 17.61 9.29 24.97 15.48 28.65 15.48 21.29 9.29 17.61"
            />
          </g>
          <g id="cube_1_right">
            <polygon
              className="cls-3"
              points="21.68 17.61 21.68 24.97 15.48 28.65 15.48 21.29 21.68 17.61"
            />
          </g>
        </motion.g>
        <motion.g
          animate={{
            x: [
              0, -8.55, -8.55, -17.1, -17.1, 0, 0, 0, 0, 0, -17.1, -17.1, -8.55,
              -8.55, 0,
            ],
            y: [0, 14.6, 14.6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14.6, 14.6, 0],
            rotate: [
              0, 120, 120, 240, 240, 360, 360, 360, 360, 360, 240, 240, 120,
              120, 0,
            ],
          }}
          transition={{
            ease: "linear",
            times: [
              0, 0.0714, 0.1428, 0.2142, 0.2856, 0.357, 0.4284, 0.4998, 0.5712,
              0.6426, 0.714, 0.7854, 0.8568, 0.9282, 1,
            ],
            duration: 10,
            repeat: Infinity,
            repeatDelay: 2.856,
          }}
        >
          <g id="cube_2_top">
            <polygon
              className="cls-2"
              points="32.52 13.94 38.71 17.61 32.52 21.29 26.32 17.61 32.52 13.94"
            />
          </g>
          <g id="cube_2_left">
            <polygon
              className="cls-3"
              points="26.32 17.61 26.32 24.97 32.52 28.65 32.52 21.29 26.32 17.61"
            />
          </g>
          <g id="cube_2_right">
            <polygon
              className="cls-1"
              points="38.71 17.61 38.71 24.97 32.52 28.65 32.52 21.29 38.71 17.61"
            />
          </g>
        </motion.g>
        <motion.g
          animate={{
            x: [
              0, -8.55, -8.55, 8.55, 8.55, 0, 0, 0, 0, 0, 8.55, 8.55, -8.55,
              -8.55, 0,
            ],
            y: [
              0, -14.6, -14.6, -14.6, -14.6, 0, 0, 0, 0, 0, -14.6, -14.6, -14.6,
              -14.6, 0,
            ],
            rotate: [
              0, 120, 120, 240, 240, 360, 360, 360, 360, 360, 240, 240, 120,
              120, 0,
            ],
          }}
          transition={{
            ease: "linear",
            times: [
              0, 0.0714, 0.1428, 0.2142, 0.2856, 0.357, 0.4284, 0.4998, 0.5712,
              0.6426, 0.714, 0.7854, 0.8568, 0.9282, 1,
            ],
            duration: 10,
            repeat: Infinity,
            repeatDelay: 2.856,
          }}
        >
          <g id="cube_3_top">
            <polygon
              className="cls-3"
              points="24 28.65 30.19 32.32 24 36 17.81 32.32 24 28.65"
            />
          </g>
          <g id="cube_3_left">
            <polygon
              className="cls-1"
              points="17.81 32.32 17.81 39.68 24 43.35 24 36 17.81 32.32"
            />
          </g>
          <g id="cube_3_right">
            <polygon
              className="cls-2"
              points="30.19 32.32 30.19 39.68 24 43.35 24 36 30.19 32.32"
            />
          </g>
        </motion.g>
      </svg>
    </span>
  )
}

export default DevelopmentIcon
